import { Terms as TermsText } from 'components/terms';
import { Heading, Stack, Text } from 'components/ui';
import { FC, useEffect } from 'react';

export interface TermsProps {
  onMount?: () => void;
  onUnmount?: () => void;
}

export const Terms: FC<TermsProps> = ({ onMount, onUnmount }) => {
  useEffect(() => {
    onMount?.();

    return () => {
      onUnmount?.();
    };
  }, [onMount, onUnmount]);

  return (
    <Stack space={2}>
      <Heading level='h4' as='h1'>
        By creating a buyer organisation, you agree to the following terms and
        conditions:
      </Heading>
      <Text as='div' fontSize={2}>
        <Stack space={1}>
          <TermsText />
        </Stack>
      </Text>
    </Stack>
  );
};
